import { useEffect, useState } from "react";
import { formatLocalDateString } from "../utils/dateUtils";

const CHECK_INTERVAL_MS = 60 * 1000;

/**
 * Local calendar day key ("YYYY-MM-DD") that updates when the day rolls over
 * (checked every minute and whenever the tab becomes visible).
 *
 * Use it as a dependency for "today" / "tomorrow" date-range memos so pages
 * left open past midnight don't keep showing yesterday's data.
 */
export const useDayKey = () => {
  const [dayKey, setDayKey] = useState(() => formatLocalDateString(new Date()));

  useEffect(() => {
    const check = () => {
      const next = formatLocalDateString(new Date());
      setDayKey((prev) => (prev === next ? prev : next));
    };
    const timer = setInterval(check, CHECK_INTERVAL_MS);
    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return dayKey;
};

export default useDayKey;
